/**
 * Local vocabulary data
 * 50 foundational English words with definitions
 */

export interface VocabularyEntry {
  word: string;
  definition: string;
}

export const vocabularyData: VocabularyEntry[] = [
  { word: "accommodate", definition: "To provide lodging or sufficient space for" },
  { word: "achieve", definition: "To successfully reach a desired objective or result" },
  { word: "acquire", definition: "To gain possession or control of something" },
  { word: "adapt", definition: "To adjust or modify to suit new conditions" },
  { word: "adequate", definition: "Sufficient for a specific requirement or purpose" },
  { word: "affect", definition: "To have an influence on or cause a change in" },
  { word: "analyze", definition: "To examine in detail to understand or explain" },
  { word: "approach", definition: "A way of dealing with or considering something" },
  { word: "appropriate", definition: "Suitable or proper in the circumstances" },
  { word: "assess", definition: "To evaluate or estimate the nature or quality of" },
  { word: "assume", definition: "To accept something as true without proof" },
  { word: "benefit", definition: "An advantage or profit gained from something" },
  { word: "capacity", definition: "The maximum amount that something can contain" },
  { word: "circumstance", definition: "A fact or condition connected with an event" },
  { word: "communicate", definition: "To share or exchange information or ideas" },
  { word: "complex", definition: "Consisting of many interconnected parts" },
  { word: "concept", definition: "An abstract idea or general notion" },
  { word: "conduct", definition: "To organize and carry out an activity" },
  { word: "consequence", definition: "A result or effect of an action or condition" },
  { word: "consistent", definition: "Acting or done in the same way over time" },
  { word: "constitute", definition: "To be a part or component of something" },
  { word: "context", definition: "The circumstances that form the setting" },
  { word: "contribute", definition: "To give something to help achieve a purpose" },
  { word: "coordinate", definition: "To bring different elements into a relationship" },
  { word: "create", definition: "To bring something into existence" },
  { word: "demonstrate", definition: "To clearly show the existence of something" },
  { word: "derive", definition: "To obtain something from a specified source" },
  { word: "design", definition: "To plan and make something for a specific purpose" },
  { word: "distinct", definition: "Recognizably different in nature from others" },
  { word: "distribute", definition: "To give shares of something to each person" },
  { word: "diverse", definition: "Showing a great deal of variety" },
  { word: "economy", definition: "The system of production and consumption" },
  { word: "emphasize", definition: "To give special importance or prominence to" },
  { word: "enable", definition: "To make something possible or able to happen" },
  { word: "encounter", definition: "To meet or come across something unexpectedly" },
  { word: "enhance", definition: "To improve the quality or value of something" },
  { word: "establish", definition: "To set up on a firm or permanent basis" },
  { word: "estimate", definition: "To roughly calculate or judge the value of" },
  { word: "evaluate", definition: "To assess the nature, ability, or quality of" },
  { word: "evidence", definition: "Information that indicates something is true" },
  { word: "expand", definition: "To increase in size, number, or importance" },
  { word: "facilitate", definition: "To make an action or process easier" },
  { word: "factor", definition: "A circumstance that contributes to a result" },
  { word: "function", definition: "The purpose or intended use of something" },
  { word: "generate", definition: "To cause something to arise or come about" },
  { word: "identify", definition: "To establish the identity of someone or something" },
  { word: "impact", definition: "The effect or influence of one thing on another" },
  { word: "implement", definition: "To put a decision or plan into effect" },
  { word: "indicate", definition: "To point out or show something" },
  { word: "interpret", definition: "To explain the meaning of information or actions" }
];

/**
 * Get a random vocabulary entry from the dataset
 * @returns Random word with its definition
 */
export function getRandomWord(): VocabularyEntry {
  const randomIndex = Math.floor(Math.random() * vocabularyData.length);
  return vocabularyData[randomIndex];
}

/**
 * Get all vocabulary entries
 * @returns Complete array of all words
 */
export function getAllWords(): VocabularyEntry[] {
  return vocabularyData;
}

/**
 * Get total number of words in vocabulary
 * @returns Count of available words
 */
export function getVocabularySize(): number {
  return vocabularyData.length;
}

